import React, { useEffect } from 'react';
import { Container, Box, Typography } from '@mui/material';
import { useGlobal } from '../contexts/GlobalContext';

const DashboardPage = () => {
  const { setCurrentContext } = useGlobal();
  useEffect(() => {
    setCurrentContext({
      product: 'eval',
      page: 'dashboard',
    });
    return () => setCurrentContext(null);
  }, [setCurrentContext]);

  return (
  <Container maxWidth="xl" sx={{ mt: 4 }}>
    <Box sx={{ textAlign: 'center', py: 8 }}>
      <Typography variant="h4" color="text.secondary" gutterBottom>
        Dashboard
      </Typography>
      <Typography variant="body1" color="text.secondary">
        Coming soon.
      </Typography>
    </Box>
  </Container>
  );
};

export default DashboardPage;
